export default function useWarnToast(message: string, life: number = 5000): void {
  const nuxtApp = useNuxtApp()
  const { $toast } = nuxtApp
  const { t } = nuxtApp.$i18n

  $toast.add({
    severity: 'warn',
    summary: 'Warning',
    detail: t(message),
    life: life,
  })
}
